export const URLParam = {
  Emails: 'Emails',
  Statuses: 'Statuses',
  Year: 'Year',
  Month: 'Month',
  SortBy: 'SortBy',
  SortingType: 'SortingType',
};
